module.exports = __webpack_public_path__ + "img/sa-shirt@3x.f84b40b7.png";